export function compareGameNames(gameNameA: string, gameNameB: string): number {
  const cleansedGameNameA = cleanseGameName(gameNameA);
  const clenasedGameNameB = cleanseGameName(gameNameB);
  return cleansedGameNameA.localeCompare(clenasedGameNameB);
}

function cleanseGameName(gameName: string): string {
  return (gameName || '').replace(' ', '').toLowerCase();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/helpers/gamename-helper.ts